import { Enabling } from '@core/models/enabling.model';
import { Procedure } from '@core/models/procedures.model';
import { WorkGroup } from '@core/models/work-unit.model';
import { Dictionary, EntityAdapter } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';

import { CoreState } from './core.models';
import { coreFK, getCacheAdapter } from './core.reducer';


const feature = (state: any): CoreState => state[coreFK];

const currentUser = createSelector(feature, (state => state.currentUser));
const accessToken = createSelector(feature, (state => state.accessToken));

const persisted = createSelector(
  currentUser,
  accessToken,
  (user, token) => ({ currentUser: user, accessToken: token })
);

const selectEnablings = createSelector(feature, (state => state.cache.enablings));
const enablingsSelectors = getCacheAdapter('enablings').getSelectors(selectEnablings);

const enablings = {
  ...enablingsSelectors,
  selectById: createSelector(
    enablingsSelectors.selectEntities,
    (entities: Dictionary<Enabling>, props: { id: number }) => entities[props.id]
  )
};

const selectExternalWs = createSelector(feature, (state => state.cache.externalWs));
const externalWsSelectors = getCacheAdapter('externalWs').getSelectors(selectExternalWs);

const externalWs = {
  ...externalWsSelectors
};

const selectProcedures = createSelector(feature, (state => state.cache.procedures));
const proceduresSelectors = (getCacheAdapter('procedures') as EntityAdapter<Procedure>).getSelectors(selectProcedures);

const procedures = {
  ...proceduresSelectors,
  selectById: createSelector(
    proceduresSelectors.selectEntities,
    (entities: Dictionary<Procedure>, props: { id: number }) => entities[props.id]
  )
};

const selectWorkGroups = createSelector(feature, (state => state.cache.workGroups));
const workGroupsSelectors = (getCacheAdapter('workGroups') as EntityAdapter<WorkGroup>).getSelectors(selectWorkGroups);

const workGroups = {
  ...workGroupsSelectors,
  selectById: createSelector(
    workGroupsSelectors.selectEntities,
    (entities: Dictionary<WorkGroup>, props: { id: number }) => entities[props.id]
  )
};


export const coreSelectors = {
  currentUser,
  accessToken,
  persisted,

  cache: {
    enablings,
    externalWs,
    procedures,
    workGroups
  }
};
